import { HudIcon } from '../../../Icons/HudIcons';
import { Container } from './NotificationBanner.styles';

export const SKINS = ['default', 'positive', 'destructive', 'warning'] as const;

type NotificationBannerProps = {
  skin: (typeof SKINS)[number];
  suffix?: React.ReactNode;
  'aria-label'?: string;
};

const NotificationBanner: React.FC<React.PropsWithChildren<NotificationBannerProps>> = ({
  skin,
  children,
  suffix,
  'aria-label': ariaLabel,
}) => {
  return (
    <Container className={skin} role="banner" aria-label={ariaLabel}>
      <HudIcon icon="designSystem.infoCircle" size="20px" />
      <div className="content">{children}</div>
      {suffix}
    </Container>
  );
};

export default NotificationBanner;
